/** English plural forms. Every other English string is its own key, so it needs no entry here. */
const en = {
  '{count} simultaneous screens': {
    one: '{count} simultaneous screen',
    other: '{count} simultaneous screens',
  },
  '{count} licences': {
    one: '{count} licence',
    other: '{count} licences',
  },
  '{count} devices at the same time': {
    one: '{count} device at a time',
    other: '{count} devices at the same time',
  },
  '{count} reviews': {
    one: '{count} review',
    other: '{count} reviews',
  },
  '{count} screens': {
    one: '{count} screen',
    other: '{count} screens',
  },
  '{count} connections': {
    one: '{count} connection',
    other: '{count} connections',
  },
  'Your line is activated as soon as payment is confirmed and your {name} keys appear in My Account.': {
    one: 'Your line is activated as soon as payment is confirmed and your {name} key appears in My Account.',
    other: 'Your line is activated as soon as payment is confirmed and your {name} keys appear in My Account.',
  },
  'You earned {count} referrals': { one: 'You earned a referral', other: 'You earned {count} referrals' },
  '{count} referrals': { one: '{count} referral', other: '{count} referrals' },
  '{count} referrals earned': { one: '{count} referral earned', other: '{count} referrals earned' },
  'Referrals earned': { one: 'Referral earned', other: 'Referrals earned' },
  '{count} hours left': { one: '{count} hour left', other: '{count} hours left' },
  '{count} days left': { one: '{count} day left', other: '{count} days left' },
  '{count} free months on the way to your line': {
    one: '{count} free month on the way to your line',
    other: '{count} free months on the way to your line',
  },
};

export default en;
